import { IHttpInterceptor, IQService } from 'angular';
import { environment } from '../../../environments/environment';
import { has } from 'lodash-es';

export function isErrorInterceptor( $q: IQService ): IHttpInterceptor {
  return {
    response( res ) {
      if ( res.config.url.includes(environment.host) ) {
        if ( res.data && res.data[ 'isError' ] ) {
          return $q.reject(res);
        }
        if ( has(res.data, 'isError') ) {
          delete res.data[ 'isError' ];
        }
      }
      return res;
    }
  };
}

isErrorInterceptor.$inject = [ '$q' ];



// WEBPACK FOOTER //
// ./app/core/interceptors/is-error.interceptor.ts